import { Injectable } from '@angular/core';
import { CaliperViewModel } from '../view-models/caliper-viewmodel';
import { ICaliperViewModel, ITraceViewModel } from '../models/interfaces';

export interface ICaliperFactoryService {
    create(trace: ITraceViewModel, coordinates: { x: number; y: number }): ICaliperViewModel | null;
}

@Injectable({
    providedIn: 'root',
})
export class CaliperFactoryService implements ICaliperFactoryService {
    create(trace: ITraceViewModel, coordinates: { x: number; y: number }): ICaliperViewModel | null {
        const { channel, layout } = trace;
        if (!trace || !layout || !channel) return null;
        let caliper = new CaliperViewModel(trace, layout, channel);

        caliper.opacity = 1;
        caliper.setPositionX(coordinates.x, 15);
        caliper.window.opacity = 0;

        return caliper;
    }
}
